module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal new-team-member animated fadeIn"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Invite Team Member")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('form', [_c('div', {
    staticClass: "float-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invite.email),
      expression: "invite.email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.invite.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invite, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")])]), _vm._v(" "), (!_vm.includePersonalMessage) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.includePersonalMessage = true
      }
    }
  }, [_vm._v("Include a personal message?")]) : _vm._e(), _vm._v(" "), (_vm.includePersonalMessage) ? _c('div', {
    staticClass: "float-label personal-message"
  }, [_c('textarea', {
    attrs: {
      "name": "message",
      "placeholder": "Message",
      "rows": "6",
      "cols": "60"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Optional Message")])]) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary is-large",
    on: {
      "click": function($event) {
        _vm.sendInvite()
      }
    }
  }, [_vm._v("Send Invitation")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1857226b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/new-team-member-modal.vue
// module id = 511
// module chunks = 0